import React, { Component } from 'react';
import classnames from 'classnames';
import "./style.css";

class TileLocation extends Component {
    render() {
        return (
            <div className="row tile-location" style={{height: 100 + 'px', width: 150 + 'px', margin: 'auto'}}>
                <div className="col-xs-12" style={{height: 100 + '%', width: 50 + '%', border: 1 + 'px solid black'}}></div>
                <div className="col-xs-12" style={{height: 100 + '%', width: 50 + '%', border: 1 + 'px solid black',  marginLeft: -1 + 'px'}}>
                    <div className="row" style={{height: 33.33 + '%', borderBottom: 1 + 'px solid black'}}>
                        <div className={classnames('col-xs-12 tile-cell', {filled: this.props.filled === "1"})} style={{height: 100 + '%',  width: 50 + '%', borderRight: 1 + 'px solid black'}}></div>
                        <div className={classnames('col-xs-12 tile-cell', {filled: this.props.filled === "2"})} style={{height: 100 + '%',  width: 50 + '%'}}></div>
                    </div>
                    <div className="row" style={{height: 33.33 + '%', borderBottom: 1 + 'px solid black'}}>
                        <div className={classnames('col-xs-12 tile-cell', {filled: this.props.filled === "3"})} style={{height: 100 + '%', width: 50 + '%', borderRight: 1 + 'px solid black'}}></div>
                        <div className={classnames('col-xs-12 tile-cell', {filled: this.props.filled === "4"})} style={{height: 100 + '%', width: 50 + '%',}}></div>
                    </div>
                    <div className="row" style={{height: 33.33 + '%'}}>
                        <div className={classnames('col-xs-12 tile-cell', {filled: this.props.filled === "5"})} style={{height: 100 + '%', width: 50 + '%', borderRight: 1 + 'px solid black'}}></div>
                        <div className={classnames('col-xs-12 tile-cell', {filled: this.props.filled === "6"})} style={{height: 100 + '%', width: 50 + '%'}}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TileLocation;


// WEBPACK FOOTER //
// ./src/components/admin/homepagemenu/tile-location.jsx